import { VueConstructor } from "vue";
import Vue from "vue";
import AutoPostingToXSetting from "@/views/PageMore/components/AutoPostingToXSetting";
import BannerPWA from "@/views/PageMore/components/BannerPWA";
import LastOnlineVisibilitySetting from "@/views/PageMore/components/LastOnlineVisibilitySetting";
import MoreMenuProfileInfo from "@/views/PageMore/components/MoreMenuProfileInfo";
import { IMoreMenuItem, MENU_MODULES } from "@/views/PageMore/config";
import MoreMenuItemDefault from "./Integration/MoreMenuItemDefault";
import MoreMenuItemNSFWUserSetting from "./Integration/MoreMenuItemNSFWUserSetting";
import MoreMenuItemSeparator from "./Integration/MoreMenuItemSeparator";

export function getMoreMenuItem(item: IMoreMenuItem): VueConstructor<Vue> {
  switch (item.name) {
    case MENU_MODULES.PWA_BANNER:
      return BannerPWA;
    case MENU_MODULES.PROFILE_INFO:
      return MoreMenuProfileInfo;
    case MENU_MODULES.NSFW_USER_SETTINGS:
      return MoreMenuItemNSFWUserSetting;
    case MENU_MODULES.SEPARATOR:
      return MoreMenuItemSeparator;
    case MENU_MODULES.ONLINE_USER_SETTINGS:
      return LastOnlineVisibilitySetting;
    case MENU_MODULES.TWITTER_AUTO_POSTING_SETTINGS:
      return AutoPostingToXSetting;
    default:
      return MoreMenuItemDefault;
  }
}
